import type { FieldElement } from '../../format/form-definition';
import { UNTITLED } from '../canvas/CanvasField';

export const fieldName = (field: FieldElement): string => {
  return field.label.trim() || UNTITLED.field;
};
